export const pageTitle = (title) => {
  return ( document.title = title + " - Arino");
}